import type { Step } from "../../hooks/useLeadFormState";

export default function StepIndicators({
  steps,
  step,
  stepLabel,
}: {
  steps: Exclude<Step, "done">[];
  step: Step;
  stepLabel: (s: Exclude<Step, "done">) => string;
}) {
  const currentIndex = steps.indexOf(step as any);

  return (
    <div className="tdb-steps">
      {steps.map((s, i) => {
        const isCurrent = step === s;
        const isDone = currentIndex > i;

        return (
          <div key={s} className="tdb-stepItem">
            <div
              className={`tdb-stepDot ${isCurrent ? "is-current" : isDone ? "is-done" : "is-idle"}`}
            >
              {i + 1}
            </div>
            {i < steps.length - 1 && <div className="tdb-stepLine" />}
          </div>
        );
      })}

      <span className="tdb-stepLabel">{stepLabel(step as any)}</span>
    </div>
  );
}
